export const API_ENDPOINTS = {
    DASHBOARD: {
        SECTIONS: '/dashboard/dashboard-item-sections',
        ITEMS: '/dashboard/dashboard-items',
        ORDERS_PRODUCTS_PER_DAY_NOT_SENT: '/dashboard/orders-products-per-day-not-sent',
        ORDERS_PRODUCTS_PER_DAY_NOT_SENT_BY_ORDER: '/dashboard/orders-products-per-day-not-sent-by-order',
        OFFLINE_ORDERS_BY_PRODUCT_TYPE: '/dashboard/offline-orders-by-product-type',
        ORDERS_PRODUCTS_DELAYED: '/dashboard/orders-products-delayed',
        ORDERS_PRODUCTS_DELAYED_BY_ORDER: '/dashboard/orders-products-delayed-by-order'
    },
    ADVICE_NOTES: {
        LIST: '/advice-notes/advice-notes',
        ATTACHMENTS: '/advice-notes/advice-notes/attachments'
    },
    CAMPAIGNS: {
        FOR_SHIPPING_LABEL: '/jmd-campaign/campaigns-for-shipping-label'
    },
    CARRIERS: {
        LIST: '/carriers/carriers/dicts/carriers',
        DETAILS: '/carriers/carriers'
    },
    CALCULATIONS: {
        IMPOSITION_PAPER_CONFIGURATION: (impositionId: number | string): string =>
            `/calculations/calculations/imposition/${impositionId}/paper-configuration`
    },
    COMPLAINTS: {
        JOB_NUMBERS: '/complaints/complaints/job-numbers',
        ORDER_NUMBERS: '/complaints/complaints/order-numbers'
    },
    CUSTOMERS: {
        ADDRESSES: '/customers/customer-addresses'
    },
    DELIVERIES: {
        COOPERANT_STATUSES: '/deliveries/dicts/cooperant-delivery-statuses'
    },
    GEOLOCALIZATIONS: {
        COUNTRIES: '/geolocalizations/geolocalizations/dicts/countries'
    },
    JOBS: {
        LIST: '/jobs/jobs',
        DETAILS: '/jobs/jobs',
        JOB_NOTES: '/jobs/jobs',
        CHANGE_HISTORY: '/jobs/jobs',
        CREATE_NEW_JOB: '/jobs/create-new-job',
        SEND_MATERIAL_REQUIREMENT: '/jobs/jobs/send-material-requirement',
        PRINT_COLOURS: '/jobs/dicts/job-print-colours',
        COLOUR_TEMPLATES: '/jobs/dicts/job-colour-templates',
        MACHINES: '/jobs/jobs/machines',
        DIE_CUTTERS: '/jobs/jobs/die-cutters',
        JOB_NUMBERS: '/jobs/job-numbers',
        CARD_PRINT: '/jobs/jobs/card-print',
        REPRINT_JOBS: '/jobs/reprint-jobs',
        IMPOSITIONS: '/jobs/impositions',
        IMPOSITION_TASKS: '/jobs/imposition-tasks',
        COPY_TASK_PARAMETERS: '/jobs/imposition-tasks/copy-parameters',
        REASSIGN_PARALLEL_COMPONENTS: '/jobs/imposition-tasks/reassign-parallel-components',
        REASSIGN_COMPONENTS_TO_IMPOSITIONS: '/jobs/reassign-components-to-impositions',
        IMPOSITION_STATUSES: (jobId: number | string) => `/jobs/jobs/${jobId}/imposition-statuses`,
        IMPOSITION_PAPER: (impositionId: number | string) => `/jobs/impositions/${impositionId}/paper`
    },
    REPORTING_AND_ANALYSIS_JOBS: {
        NCF_JOBS: '/reports/report-jobs',
        PRODUCTS_REPORT: '/reports/report-jobs-products',
        PARTS_REPORT: '/reports/report-jobs-parts'
    },
    REPORTING_AND_ANALYSIS_ORDERS: {
        SENT_ORDERS_BY_DATE: '/reports/report-sent-orders-by-date',
        SENT_ORDERS_BY_DATE_CF: '/reports/report-sent-orders-by-date-cf',
        SENT_ORDERS_BY_WEEK_AVERAGE: '/reports/report-sent-orders-by-week-average',
        SENT_ORDERS_BY_MONTH_AVERAGE: '/reports/report-sent-orders-by-month-average',
        PLACED_ORDERS_BY_DATE: '/reports/report-placed-orders-by-date',
        PM_PRODUCTS: '/reports/reports/dicts/pm-products',
        ORDERS_IN_PROGRESS: '/reports/report-orders-in-progress',
        REALIZATION_REPORT_ORDERS: '/orders/realization-report-orders',
        REPORT_CARD_PRINT: '/orders/orders/report-card-print',
        ORDERS_STATUSES: '/reports/report-orders-statuses',
        LIEFERSCHEIN_PRINTS: '/reports/lieferschein-prints',
        SENT_ORDERS_WITH_WEIGHT: '/reports/report-sent-orders-with-weight'
    },
    REPORTS: {
        SESSIONS: {
            SHIFT_SUMMARIES: '/reports/reports-shift-summaries'
        },
        RUNTIME: {
            REPORT_PROCESS_CODES: '/reports/reports/dicts/report-process-codes',
            SCHEDULED_TASKS: '/reports/reports/scheduled-tasks',
            REPORT_ITEMS: '/reports/report-items',
            REPORT_ITEM_PLATES: '/reports/report-item-plates',
            REPORT_ITEMS_BY_NUMBER: '/reports/report-items-by-number',
            REPORT_ITEMS_NEXT_UNREPORTED_PLATES: '/reports/report-items-next-unreported-plates',
            NEXT_PLATE_TO_REPORT: '/reports/next-plate-to-report',
            REPORT_OUT_OF_SEQUENCE_CODES: '/reports/reports/dicts/report-out-of-sequence-codes',
            REPORT_COMMENT_CODES: '/reports/reports/dicts/report-comment-codes',
            REPORT_SHIPPING_GROUPS: '/reports/reports/dicts/shipping-groups',
            ADDITIONAL_ACTION_PROCESS_PRODUCTION_SITE: '/reports/reports/dicts/additional-action-process-production-site',
            ADDITIONAL_ACTION_REPORT_PROCESS_CODE_PRODUCTION_SITE:
                '/reports/reports/dicts/additional-action-report-process-code-production-site',
            REPORT_ITEM_ORDERS: '/reports/report-item-orders',
            REPORT_ITEMS_ORDERS_OF_JOB: '/reports/report-items/orders-of-job',
            REPORT_ITEM_ORDER_JOBS: '/reports/report-item-order-jobs',
            REPORT_ITEM_COLOURS: '/reports/report-item-colours',
            CODE_COMPLIANCES: '/reports/code-compliances',
            CODE_COMPLIANCE_PATTERNS: '/reports/code-compliance-patterns'
        },
        EXECUTION: {
            REPORTS: '/reports/reports',
            BLACK_BOX_COUNTER_SWITCH: '/reports/reports/black-box-counter-switch',
            PRINECT_AMOUNT: '/reports/prinect-amount',
            PRINECT_MAKE_READY_AMOUNT: '/reports/prinect-make-ready-amount'
        },
        MATERIALS: {
            MATERIAL_TYPES: '/reports/material-types',
            MATERIALS: '/reports/materials',
            CREATE_REPORT_MATERIAL_RESERVATIONS: '/reports/create-report-material-reservations'
        },
        REVIEW: {
            REPORTS_SHIFT_SUMMARIES: '/reports/reports-shift-summaries',
            REPORTS_REVIEW: '/reports/reports-review',
            REPORTS: '/reports/reports',
            ACTIVE_REPORTS: '/reports/active-reports',
            SIMPLE_REPORTS: '/reports/simple-reports',
            REPORT_STATUSES: '/reports/reports/dicts/report-statuses',
            REPORT_OBJECT_TYPES: '/reports/reports/dicts/report-object-types',
            REVIEW_PROCESS_CODE_REPORT: '/reports/review-process-code-report'
        },
        PAPER: {
            PAPER_REPORTS: '/reports/paper-reports',
            REPORT_PALLETS: '/reports/report-pallets',
            CHECK_PALLET_PARAMETER: '/reports/report-pallets/check-parameter'
        }
    },
    BLACK_BOXES: {
        COUNTER: '/black-boxes/black-box-counter',
        LIGHTS: '/black-boxes/black-box/lights'
    },
    INTERNAL_PALLETS: {
        NEXT_PROCESS_SUGGESTIONS: '/internal-pallets/next-process-pallet-suggestions'
    },
    PLATE_ORDERS: {
        ORDERS: '/plate-orders/plate-orders',
        REASONS: '/plate-orders/dicts/plate-order-reasons',
        MACHINE_PLATE_ITEMS: '/plate-orders/machine-plate-items'
    },
    SHIPMENTS: {
        REPORTS: {
            REPORTS_SHIFT_SUMMARIES: '/shipments/shipments-reports-shift-summaries',
            REPORTS: '/shipments/shipments-reports',
            REVIEW_PROCESS_CODE_SHIPMENT_REPORT: '/shipments/review-process-code-shipment-report'
        }
    },
    COOPERANT_ORDERS: {
        LIST: '/orders/cooperant-orders',
        BY_ORDER_NUMBERS: '/orders/cooperant-orders/by-order-numbers',
        DETAILS: (orderId: number | string) => `/orders/cooperant-orders/${orderId}`,
        VARIANT_MOCKUP: (orderId: number | string, variantId: number | string) =>
            `/orders/cooperant-orders/${orderId}/variants/${variantId}/mockup`
    },
    ORDERS: {
        LIST: '/orders/orders',
        DETAILS: '/orders/orders',
        COLLECTOR: '/orders/orders-collector',
        PRODUCTS: '/orders/orders-product',
        PRODUCT_COMPONENTS: '/orders/orders-product-component',
        PRODUCT_FILE_UPLOAD: '/orders/order-product/file/upload',
        FOR_SHIPPING_LABELS: '/orders/orders-for-shipping-labels',
        ORDER_FILE_UPLOAD: '/orders/order/file/upload',
        COPY_ORDER_PRODUCT_ATTACHMENTS: '/orders/copy-order-product-attachments',
        STATUSES: '/orders/orders/dicts/statuses',
        PRODUCT_COMPONENT_TRANSLATIONS: '/orders/orders/dicts/product-component-translations',
        NUMBER_CONFIGURATION_TYPES: '/orders/orders/dicts/number-configuration-types',
        ORDER_COMMENTS: '/orders/order-comments',
        GRAPHIC_FILE_DELIVERY_METHODS: '/orders/orders/dicts/order-graphic-file-delivery-method',
        PRODUCTION_NUMBERS: '/orders/orders-production-numbers'
    },
    PRODUCTION_SITES: {
        LIST: '/production-sites/production-sites',
        BASE: '/production-sites/production-sites-base',
        DETAILS: '/production-sites/production-sites'
    },
    SCALES: {
        READING: (productionSiteId: number | string): string => `/scales/production-sites/${productionSiteId}`
    },
    PACKAGING: {
        ORDER_LOOKUP: '/sendings/address',
        ORDER_ADDRESSES: '/sendings/order-addresses',
        COURIERS: '/carriers/carriers/dicts/carriers',
        GATES: '/sendings/gates/dicts/gates',
        BOXES_INFO: '/sendings/boxes-info',
        COLLECTING_BOXES: '/sendings/collecting-boxes',
        LABELS: '/sendings/label',
        LABELS_REPRINT: '/sendings/reprint-label',
        PACKAGE: '/sendings/package',
        PACKAGE_LABELS: '/sendings/send-package',
        PACKAGE_LABELS_REPRINT: '/sendings/reprint-package-label',
        LABEL_PRINT_HISTORY: '/sendings/label-print-history',
        LIEFERSCHEIN: '/reports/print-lieferschein-pdf'
    },
    PRODUCTION_PROCESSES: {
        DETAILS: '/production-processes/processes'
    },
    PAPERS: {
        LIST: '/papers/papers',
        CERTIFICATES: '/papers/papers/dicts/paper-certificates'
    },
    MATERIALS: {
        LIST: '/materials/materials'
    },
    MAINTENANCE: {
        ACCIDENTS: {
            REVIEW: '/accidents/accidents-review'
        }
    },
    MACHINES: {
        LIST: '/machines/machines',
        RAW: '/machines/machines-raw',
        CALCULATION_MACHINES: '/calculations/calculations/machines',
        DICTS: '/machines/machines/dicts',
        MACHINE_PROCESS_COSTS: '/machines/machines/machine-process-costs',
        MACHINE_FOLDING_WASTE_CONFIGURATIONS: '/machines/machine-folding-waste-configurations',
        MACHINE_COLOUR_WASTE_CONFIGURATIONS: '/machines/machine-colour-waste-configurations',
        COLOUR_TYPES: '/machines/machines/dicts/colour-types',
        COST_CENTER_NUMBERS: '/machines/machines/dicts/cost-center-numbers',
        MACHINE_WASTE_PERCENT_CONFIGURATIONS: '/machines/machines/{machineId}/waste-percent-configurations',
        PRODUCTION_PROCESSES: '/production-processes/processes',
        PRODUCTION_PROCESSES_RAW: '/production-processes/processes-raw',
        PRODUCTION_DEPARTMENTS: '/production-departments/dicts/production-departments'
    },
    PRODUCTION_EFFICIENCIES: {
        PROCESS_DURATION_CONFIGURATIONS: '/production-efficiencies/production-process-duration-configurations',
        DIGITAL_ROLL_EFFICIENCIES: '/production-efficiencies/digital-printing-from-roll-efficiencies',
        DIGITAL_ROLL_EFFICIENCY_BULK: '/production-efficiencies/digital-printing-from-roll-efficiency-bulk',
        ROLL_CUTTING_EFFICIENCIES: '/production-efficiencies/roll-cutting-from-roll-efficiencies',
        ROLL_CUTTING_EFFICIENCY_BULK: '/production-efficiencies/roll-cutting-from-roll-efficiency-bulk',
        BILLBOARD_COLLECTOR_EFFICIENCIES: '/production-efficiencies/billboard-collector-efficiencies',
        TINNING_EFFICIENCIES: '/production-efficiencies/tinning-efficiencies',
        LITHO_LAMINATION_EFFICIENCIES: '/production-efficiencies/litho-lamination-efficiencies',
        PUNCHING_EFFICIENCIES: '/production-efficiencies/punching-efficiencies',
        DRILLING_EFFICIENCIES: '/production-efficiencies/drilling-efficiencies',
        CALENDAR_ASSEMBLY_EFFICIENCIES: '/production-efficiencies/calendar-assembly-efficiencies',
        STACK_DIE_CUTTING_EFFICIENCIES: '/production-efficiencies/stack-die-cutting-efficiencies',
        LAMINATION_EFFICIENCIES: '/production-efficiencies/lamination-efficiencies',
        SPIRAL_EFFICIENCIES: '/production-efficiencies/spiral-efficiencies',
        MANUAL_WORKS: '/production-efficiencies/manual-works'
    },
    PACKAGE_DEFINITIONS: {
        BOX_TYPES: '/package-definitions/dicts/box-types',
        PACKAGE_TYPES: '/package-definitions/dicts/package-types'
    },
    DIE_CUTTERS: {
        OWNERSHIP_TYPES: '/die-cutters/die-cutters/dicts/ownership-types'
    },
    SHIPPING_LABELS: {
        LIST: '/shipping-labels/shipping-labels',
        DETAILS: '/shipping-labels/shipping-labels',
        CREATE_FROM_SHIPPING_ORDER: '/shipping-labels/shipping-label-from-shipping-order',
        CREATE_FROM_ECOMMERCE_ORDER: '/shipping-labels/shipping-label-from-ecommerce-order',
        CREATE_FROM_CAMPAIGN: '/shipping-labels/shipping-label-from-campaign',
        CREATE_CARRIER_LABEL: '/shipping-labels/carrier-label',
        CREATE_ADDITIONAL_LABEL: '/shipping-labels/additional-label',
        PRINT: '/shipping-labels/print-shipping-label',
        PRINT_SSCC: '/shipping-labels/print-sscc-label',
        PRINT_SSCC_BULK: '/shipping-labels/print-sscc-labels-bulk',
        TEMPLATES: '/shipping-labels/dicts/shipping-label-templates',
        STATUSES: '/shipping-labels/dicts/shipping-label-statuses',
        TYPES: '/shipping-labels/dicts/shipping-label-types',
        DESTINATIONS: '/shipping-labels/dicts/shipping-label-destinations',
        AVAILABLE_GOODS: '/shipping-labels/shipping-labels/position-available-goods',
        PACKAGE_CONFIGURATIONS: '/shipping-labels/shipping-labels/position-available-goods-packages-configurations'
    },
    SHIPPING_ORDERS: {
        LIST: '/shipping-orders/shipping-orders',
        DETAILS: '/shipping-orders/shipping-orders',
        STATUSES: '/shipping-orders/dicts/shipping-order-statuses',
        CREATE_FROM_PM: '/shipping-orders/shipping-order-from-pm',
        UPDATE_GOOD_ITEMS: '/shipping-orders/shipping-orders-good-items',
        CREATE_FROM_ORDERS: '/shipping-orders/shipping-order-from-orders',
        FOR_SHIPPING_LABELS: '/shipping-orders/shipping-orders-for-shipping-labels'
    },
    SCHEDULE_PRIORITIZATION: {
        PRODUCTION_SITES: '/schedule-prioritization/production-sites',
        SCHEDULED_TASKS: '/schedule-prioritization/scheduled-tasks',
        PRIORITIZED_TASKS: '/schedule-prioritization/prioritized-tasks'
    },
    DISTRIBUTORS: {
        LIST: '/distributors/distributors',
        DETAIL: '/distributors/distributors',
        SET_STATUS: '/distributors/distributors',
        CARRIERS_DELIVERY_METHODS: '/carriers/carriers-distributors-delivery-methods'
    },
    PERSONAL_PICKUPS: {
        LIST: '/personal-pickups/personal-pickups',
        DETAIL: '/personal-pickups/personal-pickups',
        CREATE_PERSONAL_PICKUP: '/personal-pickups/create-personal-pickup',
        CREATE_PERSONAL_PICKUP_FOR_PACKAGE: '/personal-pickups/create-personal-pickup-for-package',
        ORDERS: '/personal-pickups/orders',
        PACKAGES: '/personal-pickups/packages'
    },
    APP_MANAGEMENT: {
        WHATS_NEW_LATEST: '/app-management/whats-new/latest'
    },
    SENDINGS: {
        ADDRESS_LOOKUP: '/sendings/address',
        ORDER_ADDRESSES: '/sendings/order-addresses',
        BOXES_INFO: '/sendings/boxes-info',
        COLLECTING_BOXES: '/sendings/collecting-boxes',
        GATES: '/sendings/gates/dicts/gates',
        LABEL: '/sendings/label',
        MANUAL_SHIPMENT: '/sendings/manual-shipment',
        SINGLE_LABEL: '/sendings/single-label',
        CONTAINERS: '/sendings/containers',
        REPRINT_LABEL: '/sendings/reprint-label',
        PACKAGE: '/sendings/package',
        SEND_PACKAGE: '/sendings/send-package',
        REPRINT_PACKAGE_LABEL: '/sendings/reprint-package-label',
        LABEL_PRINT_HISTORY: '/sendings/label-print-history',
        GENERATE_EAN_LABELS: '/sendings/generate-ean-labels',
        GENERATE_CUSTOM_LABELS: '/sendings/generate-custom-labels',
        GENERATE_BILLBOARD_LABELS: '/sendings/generate-billboard-labels',
        GENERATE_REVISION_LABELS: '/sendings/generate-revision-labels',
        LABELS_CAMPAIGN: '/jmd-campaign/labels-campaigns',
        REVISION_LABELS_ORDER_DETAILS: '/sendings/revision-labels-order-details'
    },
    PROOF_JOBS: {
        LIST: '/proof-jobs/proof-jobs',
        DETAIL: '/proof-jobs/proof-jobs'
    },
    CERTIFICATE_APPROVALS: {
        LIST: '/certificate-approvals/certificate-approvals',
        DETAIL: (approvalId: number | string): string => `/certificate-approvals/certificate-approvals/${approvalId}`
    },
    PACKAGE_PROTOTYPE_JOBS: {
        LIST: '/package-prototype-jobs/package-prototype-jobs',
        DETAIL: (jobId: number | string): string => `/package-prototype-jobs/package-prototype-jobs/${jobId}`,
        FILES: '/package-prototype-jobs/package-prototype-job-files',
        FILE: (jobId: number | string, fileName: string): string =>
            `/package-prototype-jobs/package-prototype-job-files/${jobId}/${encodeURIComponent(fileName)}`,
        COMMENTS: (jobId: number | string): string => `/package-prototype-jobs/package-prototype-job-comments/${jobId}`
    },
    COOPERATION_JOBS: {
        LIST: '/cooperation-jobs/cooperation-jobs',
        COMMENTS: '/cooperation-jobs/cooperation-job-comments',
        DETAILS: (cooperationJobId: number | string): string => `/cooperation-jobs/cooperation-jobs/${cooperationJobId}`,
        ORDER_CARDS_PRINT: '/cooperation-jobs/cooperation-jobs/order-cards-print',
        STATUSES: '/cooperation-jobs/dicts/statuses',
        CONSUMPTION_MATERIAL_TYPES: '/cooperation-jobs/dicts/consumption-material-types',
        PAPER_CONSUMPTION_REPORT: '/cooperation-jobs/paper-consumption-report'
    },
    COOPERANT_STOCKS: {
        LIST: '/cooperants/cooperant-stocks',
        DETAILS: (stockId: number | string): string => `/cooperants/cooperant-stocks/${stockId}`,
        MATERIAL_TYPES: '/cooperants/cooperant-stocks/dicts/material-types'
    },
    ROOM_RESERVATIONS: {
        LIST: '/reservations/room-reservations',
        DETAILS: (reservationId: number | string): string => `/reservations/room-reservations/${reservationId}`,
        ROOM_TYPES: '/reservations/dicts/room-type',
        ROOM_TYPE_ALLOWED_USERS: (roomTypeId: number): string => `/reservations/room-types/${roomTypeId}/allowed-users`
    },
    USERS: {
        TOKEN: '/users/token'
    },
    WIKI: {
        ROOT_FOLDERS: '/wiki/root-folders',
        FOLDERS: '/wiki/folders',
        FOLDER_CONTENT: (folderId: number | string): string => `/wiki/folders/${folderId}`,
        ENTRIES: '/wiki/entries',
        ENTRY: (entryId: number | string): string => `/wiki/entries/${entryId}`,
        ATTACHMENTS: '/wiki/attachments',
        ATTACHMENT: (attachmentId: number | string): string => `/wiki/attachments/${attachmentId}`,
        SEARCH: '/wiki/search',
        ATTACHMENT_DOWNLOAD: (attachmentId: number | string): string => `/wiki/attachments/${attachmentId}/download`
    }
} as const
